import React from "react"
import Logo from "./logo"
import HamburgerMenu from "./hamburger-menu"

const Header = props => (
  <header className="navbar-wrapper hero-head has-background-transparent">
    <div className="level">
      <Logo theme={props.theme} />

      <HamburgerMenu theme={props.theme} />
    </div>
  </header>
)

export default Header
